import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { connectToStore } from '../../store';
import UserList from './user-list/UserList';
import UserDetails from './user-details/UserDetails';
import NotFound from '../not-found/NotFound';
import styles from './Users.module.scss';

const subRoutes = [
	{
		path: `/`,
		exact: true,
		component: UserList,
	},
	{
		path: `/details/:id`,
		exact: true,
		component: UserDetails,
	},
];

function Users() {
	const { path } = useRouteMatch();

	return (
		<div className={styles.screen}>
			<Switch>
				{/* Routes */}
				{subRoutes.map((route, index) => (
					<Route key={index} path={`${path}${route.path}`} exact={route.exact}>
						<route.component />
					</Route>
				))}

				{/* 404 */}
				<Route path="*">
					<NotFound />
				</Route>
			</Switch>
		</div>
	);
}

export default connectToStore(Users);
